import { getValueSegments, findCursorPlace } from './utils.js';
import 'tslib';
import 'date-fns/clamp';
import 'date-fns/getDaysInMonth';
import '../consts.js';

function createCaretPosPlugin(template) {
    return function (element) {
        var handleKeyDown = function (evt) {
            var event = evt;
            var selectionStart = element.selectionStart, selectionEnd = element.selectionEnd, value = element.value;
            if ([' ', '.'].includes(event.key) && selectionStart === selectionEnd) {
                var nextPos = findNextSegmentPos(value, template, selectionStart || 0);
                element.setSelectionRange(nextPos, nextPos);
            }
        };
        element.addEventListener('keydown', handleKeyDown);
        return function () { return element.removeEventListener('keydown', handleKeyDown); };
    };
}
function findNextSegmentPos(value, template, cursorPos) {
    var _a;
    var segments = getValueSegments(value, template.separators);
    var selection = [cursorPos, cursorPos];
    var currCursorPlace = findCursorPlace(segments, template.segments, template.separators, selection);
    if (currCursorPlace) {
        var nextCursorPos = 0;
        for (var i = 0; i < segments.length; i++) {
            var segment = segments[i];
            var separatorLen = ((_a = template.separators[i]) === null || _a === void 0 ? void 0 : _a.length) || 0;
            if (i === currCursorPlace.segmentIdx) {
                nextCursorPos += segment.length + separatorLen;
                return nextCursorPos;
            }
            nextCursorPos += segment.length + separatorLen;
        }
    }
    return cursorPos;
}

export { createCaretPosPlugin };
